export const appHead = {"meta":[{"name":"viewport","content":"width=device-width, initial-scale=1"},{"charset":"utf-8"},{"name":"description","content":"This is the HyperFuse Guardian Node sales page. A HyperFuse Guardian Node within Sonic's HyperGrid Framework is designed to detect and alert the network of any discrepancies in transactions or state transitions."},{"property":"og:url","content":"https://node.sonic.game"},{"property":"og:type","content":"website"},{"property":"og:title","content":"HyperFuse Guardian Node"},{"property":"og:description","content":"This is the HyperFuse Guardian Node sales page. A HyperFuse Guardian Node within Sonic's HyperGrid Framework is designed to detect and alert the network of any discrepancies in transactions or state transitions."},{"property":"og:image","content":"https://node.sonic.game/img/content.jpg"},{"name":"twitter:card","content":"summary_large_image"},{"property":"twitter:domain","content":"node.sonic.game"},{"property":"twitter:url","content":"https://node.sonic.game"},{"name":"twitter:title","content":"HyperFuse Guardian Node"},{"name":"twitter:description","content":"This is the HyperFuse Guardian Node sales page. A HyperFuse Guardian Node within Sonic's HyperGrid Framework is designed to detect and alert the network of any discrepancies in transactions or state transitions."},{"name":"twitter:image","content":"https://node.sonic.game/img/content.jpg"}],"link":[],"style":[],"script":[],"noscript":[],"title":"HyperFuse Guardian Node Sale"}

export const appBaseURL = "/"

export const appBuildAssetsDir = "/_nuxt/"

export const appCdnURL = ""

export const appLayoutTransition = false

export const appPageTransition = false

export const appViewTransition = false

export const appKeepalive = false

export const appRootId = "__nuxt"

export const appRootTag = "div"

export const appRootAttrs = {"id":"__nuxt"}

export const appTeleportTag = "div"

export const appTeleportId = "teleports"

export const appTeleportAttrs = {"id":"teleports"}

export const renderJsonPayloads = true

export const componentIslands = false

export const payloadExtraction = true

export const cookieStore = true

export const appManifest = true

export const remoteComponentIslands = false

export const selectiveClient = false

export const devPagesDir = null

export const devRootDir = null

export const devLogs = false

export const nuxtLinkDefaults = {"componentName":"NuxtLink","prefetch":true,"prefetchOn":{"visibility":true}}

export const asyncDataDefaults = {"value":null,"errorValue":null,"deep":true}

export const resetAsyncDataToUndefined = true

export const nuxtDefaultErrorValue = null

export const fetchDefaults = {}

export const vueAppRootContainer = '#__nuxt'

export const viewTransition = false

export const appId = "nuxt-app"

export const outdatedBuildInterval = 3600000

export const multiApp = false